
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/ia/agendamento-de-carga",
      function () {
        return require("private-next-pages/pt-br/ia/agendamento-de-carga/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/ia/agendamento-de-carga"])
      });
    }
  